module.exports = __webpack_public_path__ + "static/tech-stack-analyzer-25091f8509a8f1a1bb8cd6ac3ceb7b3f.png";